import { render } from "./profileMenu.vue?vue&type=template&id=6279193c&scoped=true"
import script from "./profileMenu.vue?vue&type=script&lang=js"
export * from "./profileMenu.vue?vue&type=script&lang=js"

import "./profileMenu.vue?vue&type=style&index=0&id=6279193c&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6279193c"]])

export default __exports__